import clsx from "clsx";

type Props = {
	className?: string
	value: string;
};

const BillingSettingsProjectValue = ({ className, value }: Props) => {
	return <div className={clsx("mt-1 text-sm font-light text-gray-500", className)}>Projekteinstellung: <span className="text-accent-700">{value}</span></div>;
};

export default BillingSettingsProjectValue;